const ANALYTICS_ID = process.env.REACT_APP_ANALYTICS_ID;

export default ANALYTICS_ID;
